<template>
  <div>
    <label v-if="label" class="heading smaller-heading mb-0 pb-0">{{ label }}</label>
    <label v-if="$slots.subLabel" class="bmd-label-static mt-0 mb-3">
      <slot name="subLabel"></slot>
    </label>
    <div
      v-if="!editing"
      data-test="termDisplayName"
      class="cursor-pointer"
      @click="setEditing(true)"
    >
      {{ termDisplayName(value) || 'No term set' }}
    </div>
    <FormSelect
      v-else
      v-on-clickaway="() => setEditing(false)"
      data-test="termSelect"
      :value="value"
      :config="{ options: terms, searchable: true }"
      :custom-label="termDisplayName"
      :placeholder="placeholder"
      :disabled="disabled"
      track-by="id"
      class="cursor-pointer"
      @input="update"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { directive as onClickaway } from 'vue-clickaway2'
import FormSelect from '@/components/Forms/FormSelect'

export default {
  components: { FormSelect },
  directives: { onClickaway },
  props: {
    terms: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    alwaysEditing: {
      tyle: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
  },
  data: (vm) => ({ editing: vm.alwaysEditing }),
  computed: mapGetters([ 'termDisplayName' ]),
  methods: {
    update (term) {
      this.$emit('input', term)
    },
    setEditing (editing) {
      if (!this.alwaysEditing) this.editing = editing
    },
  },
}
</script>
